import React from "react";
import css from "../../css/agents/active-filters.module.css";
import PropTypes from "prop-types";
import ActiveFilter from "./ActiveFilter";

const ActiveFilters = (props) => {
    const { filters, onClear, onClearAll } = props;
    let onlyLocation = true;

    const activeFilters = Object.entries(filters)
        .map((filter) => {
            const name = filter[0];
            const value = filter[1];

            if (!value.value) {
                return null;
            }

            if (onlyLocation && name !== "location") {
                onlyLocation = false;
            }

            const onDel = name === "location" ? null : onClear;

            return (
                <ActiveFilter
                    key={name}
                    name={name}
                    label={value.title}
                    value={value.label}
                    onDelete={onDel}
                />
            );
        })
        .filter((v) => v);

    if (!activeFilters.length) {
        return null;
    }

    return (
        <div className={css.activeFilters}>
            <div className={css.filters}>
                <h3 className={css.title}>Active Filters</h3>
                {activeFilters}
            </div>
            {!onlyLocation && (
                <div className={css.clearButton}>
                    <a href="#" onClick={onClearAll}>
                        Clear All
                    </a>
                </div>
            )}
        </div>
    );
};

ActiveFilters.propTypes = {
    filters: PropTypes.object.isRequired,
    onClear: PropTypes.func.isRequired,
    onClearAll: PropTypes.func.isRequired,
};

export default ActiveFilters;
